module.exports = __webpack_public_path__ + "static/media/Antylegionella.4d1d160c.svg";